<mat-dialog-content class="mt-4">
  <div class="d-flex flex-column align-items-center mb-3 text-center">
    <img
      fetchpriority="high"
      width="72"
      height="72"
      class="mb-4"
      src="images/organization_icon.svg"
      alt="Confirmation"
      title="Confirmation"
    />

    <p class="fw-600 mb-3 text-md-l text-m">
      Learn How to Create an Organization Account
    </p>

    <div>
      <p class="text-md-2xl text-xl">{{ currentScreen.heading }}</p>
      <p class="text-md-s text-xs">{{ currentScreen.subHeading }}</p>
      <div class="help-image">
        <img
          fetchpriority="high"
          class="object-fit-contain bg-white h-100 w-100"
          [src]="currentScreen.imageUrl"
          alt="Learn More"
          title="Learn More"
        />
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="px-3 py-2 gap-3">
  <div
    class="w-100 d-flex"
    [class]="
      currentStep == 0 ? 'justify-content-end' : 'justify-content-between'
    "
  >
    <button class="btn btn-bordered-red me-2" mat-dialog-close>Cancel</button>
    <div class="d-flex justify-content-between gap-2">
      @if (currentStep != 0) {
      <button class="btn btn-tertiary-bordered" (click)="onPrev()">
        Previous
      </button>
      } @if (currentStep !== learnMoreScreens.length - 1) {
      <button class="btn btn-secondary" (click)="onNext()">Next</button>
      } @else {
      <button class="btn btn-secondary" [mat-dialog-close]="true">
        Continue to Register
      </button>
      }
    </div>
  </div>
</mat-dialog-actions>
